export class VideoDettaglioItem{
    constructor(){
        this.ytVideoId,
        this.imgThumbSource;
    }
}